import http from '../../services/httpService';

const apiEndpoint = '/locales';

export const getActiveLocales = async () => {
  const url  = `${apiEndpoint}`
  const result = await http.get(url);
  return result;
}